// Función auxiliar para convertir fechas de dd/MM/yyyy a yyyy-MM-dd (formato ISO)
export const convertDateToISOForDateNavigator = (dateString: string) =>
{
    if(!dateString)
    {
        return '';
    }

    try
    {
        // Si ya está en formato ISO (yyyy-MM-dd), devolverlo tal como está
        if(/^\d{4}-\d{2}-\d{2}$/.test(dateString))
        {
            return dateString;
        }

        // Si está en formato dd/MM/yyyy, convertir a ISO
        if(/^\d{2}\/\d{2}\/\d{4}$/.test(dateString))
        {
            const [day, month, year] = dateString.split('/');
            return `${year}-${month}-${day}`;
        }

        // Si está en formato MM/dd/yyyy, convertir a ISO
        if(/^\d{2}\/\d{2}\/\d{4}$/.test(dateString))
        {
            const [month, day, year] = dateString.split('/');
            return `${year}-${month}-${day}`;
        }

        // Intentar parsear como fecha estándar
        const date = new Date(dateString);
        if(isNaN(date.getTime()))
        {
            console.warn(`⚠️ [convertDateToISO] No se pudo parsear la fecha: ${dateString}`);
            return '';
        }

        return date.toISOString().split('T')[0];
    }
    catch(error)
    {
        console.error(`❌ [convertDateToISO] Error al convertir fecha: ${dateString}`, error);
        return '';
    }
};